module.exports = __webpack_public_path__ + "static/media/MentorKerryn.de711401.jpg";